/**
 * selected-point-drawer.js
 */

import React from 'react';
import {
  useTheme,
  Box,
  Typography,
  Button,
  Grid,
} from '@mui/material';
import { DISTANCE_UNIT_NAME, convertDistance } from 'utils/distance';
import { UserContext } from 'contexts/user/user-context';
import { TrackContext } from '../track-context';
import { MapContext } from '../map/map-context';
import {
  DrawerHeader,
  DrawerBase, 
  DrawerControlButton,
  DrawerControlBar,
  GridCell,
  MarkerElapsedGridCell,
  MarkerTimeGridCell,
  Subheading,
  SelectedTrackGrid,
} from './control-common';


const Header = () => {
  const theme = useTheme();
  const titleColor = theme.palette.sys.onSurface
  const { deselectPoint } = React.useContext(MapContext);
  
  return (
    <DrawerHeader backgroundColor={theme.palette.sys.surfaceContainerHighest}>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', px: 2, }}>
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', }}>
          <Button
            children='Cancel'
            sx={{ color: titleColor, textTransform: 'none' }}
            onClick={deselectPoint}
          />
        </Box>
        <Typography variant='subtitle1' sx={{ flex: 3, display: 'flex', justifyContent: 'center', color: titleColor }}>
          LOCATION
        </Typography>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', }} />
      </Box>
    </DrawerHeader>
  )
}


const SaveButton = ({ onSave }) => {
  const { saveSelectedPoint } = React.useContext(MapContext);

  return (
    <DrawerControlButton
      color='info'
      iconName='location-add'
      onClick={() => {
        if (onSave) {
          onSave();
        }
        saveSelectedPoint();
      }}
    >
      <Typography
        variant='subtitle2'
      >
        SAVE AS PIN
      </Typography>
    </DrawerControlButton>
  )
}


const Controls = (props) => {
  return (
    <DrawerControlBar
      actions={<SaveButton onSave={props.onSave} />}
    />
  );
}


export default function SelectedPointDrawer(props) {
  let {
    onSave,
    ...rest
  } = props;
  const { user } = React.useContext(UserContext);
  const { tracks } = React.useContext(TrackContext);
  const { selectedPoint } = React.useContext(MapContext);

  if (!selectedPoint) {
    return;
  }

  const track = tracks[selectedPoint.trackIdx];
  const canEdit = user
    ? !user.role.isSupervisor  // track?.userId === user.id
    : track?.userId === null;


  return (
    <DrawerBase
      {...rest}
      canCollapse={false}
      header={<Header />}
      controls={canEdit ? <Controls onSave={onSave} /> : null}
      content={<>
        <Subheading>SELECTED POINT</Subheading>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <MarkerTimeGridCell track={track} marker={selectedPoint} />
          </Grid>
          <Grid item xs={6}>
            <MarkerElapsedGridCell track={track} marker={selectedPoint} />
          </Grid>
          <Grid item xs={6}>
            <GridCell
              iconId='distance'
              content={`${Math.round(convertDistance(selectedPoint.distanceOnTrack, DISTANCE_UNIT_NAME.METERS, DISTANCE_UNIT_NAME.YARDS))} yards`}
            />
          </Grid>
        </Grid>
        <SelectedTrackGrid track={track} />
      </>}
    />
  );
}